enum ItemBonusType {
  Invalid,
  Agility,
  ArcaneResistence,
  ArcaneSpellDamage,
  Armor,
  AttackPower,
  BeastSlaying,
  Block,
  CriticalHit,
  Damage,
  DamageAndHealingSpells,
  Defense,
  Dodge,
  FireResistance,
  FireSpellDamage,
  FrostResistance,
  FrostSpellDamage,
  HealingSpells,
  HealthEvery5,
  HolySpellDamage,
  Intellect,
  ManaEvery5,
  NatureResistance,
  NatureSpellDamage,
  RangedAttackPower,
  ShadowResistance,
  ShadowSpellDamage,
  Spirit,
  Stamina,
  Strength,
  AxeSkill,
  BowSkill,
  DaggerSkill,
  GunSkill,
  MaceSkill,
  SwordSkill,
  TwoHandedAxeSkill,
  TwoHandedMaceSkill,
  TwoHandedSwordSkill,
  OnGetHitShadowBolt
}

export default ItemBonusType
